export const MaterialBidTypeEnum = {
  ENGLISH: "ENGLISH",
  DUTCH: "DUTCH",
  DIRECT_QUOTE: "DIRECT_QUOTE",
};
